var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CarouselPagination"},[_c('span',{ref:"active",staticClass:"CarouselPagination-active"},[_vm._v(_vm._s(_vm.activeIndex))]),_c('span',{staticClass:"CarouselPagination-len"},[_vm._v(" / "+_vm._s(_vm.len))])])}
var staticRenderFns = []

export { render, staticRenderFns }